import React from "react";
import { createRoot } from 'react-dom/client';
import CaptionAIApp from "./captionAI-app.jsx";
import theme from "../utils/MUI/captionAI-override.js";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { initRum } from '../utils/datadog.js';

initRum();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Router>
      <GoogleReCaptchaProvider 
        reCaptchaKey="6LfLGJslAAAAAEMhE-EzlhmxusuQenSW-5GUVtug"
        scriptProps={{
          async: false,
          defer: false,
          appendTo: "head",
          nonce: undefined,
        }}>
        <ThemeProvider theme={theme}>
          <CaptionAIApp />
        </ThemeProvider>
      </GoogleReCaptchaProvider>
    </Router>
  </React.StrictMode>
);
